"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _HubCalcEditionSelectionContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/HubCalcEditionSelectionContainer"));

var _AdditionalUnitsPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/AdditionalUnitsPicker"));

var _PlanSelectorTileHeader = _interopRequireDefault(require("./PlanSelectorTileHeader"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _CalculatorDivider = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorDivider"));

var _CalcTermSelectorContainer = _interopRequireDefault(require("./CalcTermSelectorContainer"));

var _stateUtils = require("../../utils/stateUtils");

var _itemConfigUtils = require("../../utils/itemConfigUtils");

var _Calculator = require("pricing-pages-unified-ui/components/calculator/Calculator");

var HubCalcPlanSelectorTileContainer = function HubCalcPlanSelectorTileContainer(_ref) {
  var activeHub = _ref.activeHub,
      getAvailableTerms = _ref.getAvailableTerms,
      getMerchIdForEdition = _ref.getMerchIdForEdition;

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      setActiveTerm = _useActiveTerm.setActiveTerm;

  var unitsKey = _stateUtils.HubToAdditionalUnitsParamKey[activeHub];

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var activeEdition = state.edition,
      selectedAddOns = state.addons,
      additionalUnitQuantity = state[unitsKey];
  var activeMerchId = getMerchIdForEdition(activeHub, activeEdition);
  var availableTerms = getAvailableTerms(activeMerchId);

  var _useActiveTerm2 = (0, _stateUtils.useActiveTerm)(),
      activeTerm = _useActiveTerm2.activeTerm;

  activeTerm = (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTerms);
  (0, _react.useEffect)(function () {
    setActiveTerm(activeTerm);
  }, []);

  var getDefaultTerm = function getDefaultTerm(edition) {
    var newMerchandiseId = getMerchIdForEdition(activeHub, edition);
    var availableTermsForNewMerch = getAvailableTerms(newMerchandiseId);
    return (0, _itemConfigUtils.getApplicableTerm)(activeTerm, availableTermsForNewMerch);
  };

  var setActiveEdition = function setActiveEdition(edition) {
    if (edition !== activeEdition) {
      var _setState;

      var filteredAddons = (0, _stateUtils.filterInvalidAddons)(selectedAddOns, activeHub, activeEdition, edition);
      setState((_setState = {
        edition: edition
      }, (0, _defineProperty2.default)(_setState, unitsKey, 0), (0, _defineProperty2.default)(_setState, "addons", filteredAddons), _setState));
      setActiveTerm(getDefaultTerm(edition));
    }
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_PlanSelectorTileHeader.default, null, _react.default.createElement(_CalcTermSelectorContainer.default, {
    activeTerm: activeTerm,
    merchandiseId: activeMerchId,
    onChange: setActiveTerm
  })), _react.default.createElement(_HubCalcEditionSelectionContainer.default, {
    activeEdition: activeEdition,
    setActiveEdition: setActiveEdition
  }), _react.default.createElement(_CalculatorDivider.default, null), _react.default.createElement(_AdditionalUnitsPicker.default, {
    hub: activeHub,
    merchandiseId: activeMerchId,
    term: activeTerm,
    additionalUnitQuantity: additionalUnitQuantity,
    setAdditionalUnitQuantity: function setAdditionalUnitQuantity(quantity) {
      return setState((0, _defineProperty2.default)({}, unitsKey, quantity));
    },
    setActiveEdition: setActiveEdition
  }), _react.default.createElement(_CalculatorDivider.default, null), _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServices");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServicesList");
    },
    publicComponentProps: {
      hub: activeHub,
      edition: activeEdition
    }
  }));
};

HubCalcPlanSelectorTileContainer.propTypes = {
  activeHub: _propTypes.default.oneOf(Object.values(_Hubs.default || {})),
  getAvailableTerms: _propTypes.default.func.isRequired,
  getMerchIdForEdition: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    getAvailableTerms: (0, _ItemConfigsSelectors.getAvailableTermsForMerchSelector)(state),
    getMerchIdForEdition: (0, _MerchandiseSelectors.getMerchIdForEditionSelector)(state),
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcPlanSelectorTileContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcPlanSelectorTileContainer.js
// module id = 339
// module chunks = 5 6